import React from 'react';
import { NEW_NDTV_SOCIAL_ICONS } from '../../../../../constants';
import get from 'lodash/get';
import { connect, useSelector } from 'react-redux';
import { followIconsDl } from '../../../../../helpers/datalayer-utils';

import './social-share.m.css';

const SocialShare = ({ pageType, sectionName, postion, name }) => {
  const userData = useSelector((state) => get(state, ['userData']));
  const list = name === 'drawer' ? NEW_NDTV_SOCIAL_ICONS?.slice(0, 4) : NEW_NDTV_SOCIAL_ICONS;
  return (
    <div styleName="list">
      <nav styleName={`${postion === 'vertical' ? 'vertical-icons' : ''} social-icons`}>
        {list &&
          list.map((item, index) => (
            <a
              key={index}
              styleName="icon-container"
              target="_blank"
              rel="noopener noreferrer"
              href={item.url}
              aria-label="social-icons"
              onClick={() => followIconsDl(item.name, pageType, userData, sectionName)}
            >
              <i styleName="icon" className={item.icon_code} />
            </a>
          ))}
      </nav>
    </div>
  );
};

const mapStateToProps = (state) => ({
  pageType: get(state, ['qt', 'pageType'], ''),
});

export default connect(mapStateToProps)(SocialShare);
